var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('button',{attrs:{"disabled":_vm.submitting},on:{"click":_vm.config}},[_vm._v("config")]),_c('button',{attrs:{"disabled":_vm.submitting},on:{"click":_vm.invoke}},[_vm._v("invoke")])])}
var staticRenderFns = []

export { render, staticRenderFns }